import type { WooCommerceImportSource } from '../../types';
import { UseBrandWebsiteButton } from './UseBrandWebsiteButton';
import { VariantGroupingRuleEditor } from './VariantGroupingRuleEditor';

interface WooCommerceSourceEditorProps {
  source: WooCommerceImportSource;
  onChange: (updated: WooCommerceImportSource) => void;
  brandWebsite?: string;
}

export function WooCommerceSourceEditor({ source, onChange, brandWebsite }: WooCommerceSourceEditorProps) {
  return (
    <div className="space-y-2">
      <label className="block text-xs font-medium text-gray-700">
        Shop or category URL
      </label>
      <input
        type="url"
        value={source.categoryUrl}
        onChange={(e) => onChange({ ...source, categoryUrl: e.target.value })}
        placeholder="https://shop.com  — or a category: …/product-category/watches/"
        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-mono focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
      />
      <UseBrandWebsiteButton
        value={source.categoryUrl}
        brandWebsite={brandWebsite}
        onUse={(url) => onChange({ ...source, categoryUrl: url })}
      />
      <label className="flex items-start gap-2 text-xs text-gray-700">
        <input
          type="checkbox"
          className="mt-0.5 rounded border-gray-300"
          checked={source.expandVariants !== false}
          onChange={(e) => onChange({ ...source, expandVariants: e.target.checked })}
        />
        <span>
          Import each option as its own reference (variants, grouped under the product) —
           e.g. dial colours. Turn off when the options are only sizes (wrist size, strap length) — then each product imports as one reference.
        </span>
      </label>
      <p className="text-xs text-gray-500">
        A WooCommerce shop. Paste its home page to import every product (the
        usual case for a single-brand shop), or one product category&rsquo;s
        address to import just that category, sub-categories included &mdash;
        for a retailer selling several brands. Everything imports under this
        brand; products sold with options become one reference per option
        (see above). Use Test to check first.
      </p>
      <VariantGroupingRuleEditor
        rule={source.variantGroupingRule}
        onChange={(variantGroupingRule) => onChange({ ...source, variantGroupingRule })}
      />
    </div>
  );
}
